<template>
  <div
    :id="id"
    class="element timer-wrapper text draggable"
    :class="[
      cssClasses,
      {
        selected: isSelected,
      }
    ]"
    :style="[basicStyles, textShadowStyles, transformStyles]"
  >
    <div
      class="timer-widget"
      :class="[
        animationInStyle,
        animationOutStyle,
        'vertical-' + verticalAlign,
      ]">
      <transition
        :enter-active-class="'animated ' + animationIn"
        :leave-active-class="'animated ' + animationOut"
        v-on:after-enter="afterEnter"
        v-on:before-leave="beforeLeave"
        :duration="{ leave: leaveDuration }"
        mode="">
        <div
          v-show="toggle"
          :class="loopingClass"
          :style="[animationStyles]"
        >
          <div
            v-if="
              element.showEndDateTime && element.counterFormat == 'Date & Time'
            "
            :style="[
              getTextStyles('endDateText'),
              {
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'center',
                whiteSpace: 'nowrap',
              },
            ]"
            class="end-date"
          >
            {{ endDateTime }}
          </div>
          <div :style="getTimerStyles()" class="timer">
            <!-- DAYS -->
            <div v-if="element.showDays" :style="getTimeStyles()" class="days">
              <div
                v-if="element.style == 'Basic'"
                :style="[getDigitContainerStyles()]"
                class="digit">
                <span
                  v-for="(char, index) in splitDigits(days)"
                  :key="index"
                  :style="getDigitStyles(index, splitDigits(days).length)">
                  {{ char }}
                </span>
              </div>
              <div
                v-if="element.style == 'Flip clock'"
                :style="[getTextStyles('timerText'), getFlipStyles()]"
                class="splitflap">
                <div :style="getFlapStyles('newTop')" class="half new-top">
                  {{ days }}
                </div>
                <div
                  :style="getFlapStyles('newBottom')"
                  class="half new-bottom flip1">
                  {{ days }}
                </div>
                <div
                  :style="getFlapStyles('oldTop')"
                  class="half old-top flip2"></div>
                <div
                  :style="getFlapStyles('oldBottom')"
                  class="half old-bottom"></div>
              </div>
              <div
                :style="getTextStyles('unitText')"
                v-if="element.showUnits"
                class="unit-label">
                {{ element.daysLabel }}
              </div>
            </div>
            <div
              v-if="
                !element.showUnits
                  && element.showDividers !== false
                  && element.showDays
              "
              :style="[getTextStyles('timerText'), getDividerStyles()]">
              &nbsp;
            </div>
            <!-- HOURS -->
            <div
              v-if="element.showHours"
              :style="getTimeStyles()"
              class="hours">
              <div
                v-if="element.style == 'Basic'"
                :style="[getDigitContainerStyles()]"
                class="digit">
                <span
                  v-for="(char, index) in splitDigits(hours)"
                  :key="index"
                  :style="getDigitStyles(index, splitDigits(hours).length)">
                  {{ char }}
                </span>
              </div>
              <div
                v-if="element.style == 'Flip clock'"
                :style="[getTextStyles('timerText'), getFlipStyles()]"
                class="splitflap">
                <div :style="getFlapStyles('newTop')" class="half new-top">
                  {{ hours }}
                </div>
                <div
                  :style="getFlapStyles('newBottom')"
                  class="half new-bottom flip1">
                  {{ hours }}
                </div>
                <div
                  :style="getFlapStyles('oldTop')"
                  class="half old-top flip2"></div>
                <div
                  :style="getFlapStyles('oldBottom')"
                  class="half old-bottom"></div>
              </div>
              <div
                :style="getTextStyles('unitText')"
                v-if="element.showUnits"
                class="unit-label">
                {{ element.hoursLabel }}
              </div>
            </div>
            <div
              v-if="
                !element.showUnits
                  && element.showDividers !== false
                  && element.showHours
                  && element.showMinutes
              "
              :style="[getTextStyles('timerText'), getDividerStyles()]"
              class="digit">
              :
            </div>
            <!-- MINUTES -->
            <div
              v-if="element.showMinutes"
              :style="getTimeStyles()"
              class="minutes">
              <div
                v-if="element.style == 'Basic'"
                :style="[getDigitContainerStyles()]"
                class="digit">
                <span
                  v-for="(char, index) in splitDigits(minutes)"
                  :key="index"
                  :style="getDigitStyles(index, splitDigits(minutes).length)">
                  {{ char }}
                </span>
              </div>
              <div
                v-if="element.style == 'Flip clock'"
                :style="[getTextStyles('timerText'), getFlipStyles()]"
                class="splitflap">
                <div :style="getFlapStyles('newTop')" class="half new-top">
                  {{ minutes }}
                </div>
                <div
                  :style="getFlapStyles('newBottom')"
                  class="half new-bottom flip1">
                  {{ minutes }}
                </div>
                <div
                  :style="getFlapStyles('oldTop')"
                  class="half old-top flip2"></div>
                <div
                  :style="getFlapStyles('oldBottom')"
                  class="half old-bottom"></div>
              </div>
              <div
                :style="getTextStyles('unitText')"
                v-if="element.showUnits"
                class="unit-label">
                {{ element.minutesLabel }}
              </div>
            </div>
            <div
              v-if="
                !element.showUnits
                  && element.showDividers !== false
                  && element.showMinutes
                  && element.showSeconds
              "
              :style="[getTextStyles('timerText'), getDividerStyles()]"
              class="digit">
              :
            </div>
            <!-- SECONDS -->
            <div
              v-if="element.showSeconds"
              :style="getTimeStyles()"
              class="seconds">
              <div
                v-if="element.style == 'Basic'"
                :style="[getDigitContainerStyles()]"
                class="digit">
                <span
                  v-for="(char, index) in splitDigits(seconds)"
                  :key="index"
                  :style="getDigitStyles(index, splitDigits(seconds).length)">
                  {{ char }}
                </span>
              </div>
              <div
                v-if="element.style == 'Flip clock'"
                :style="[getTextStyles('timerText'), getFlipStyles()]"
                class="splitflap">
                <div :style="getFlapStyles('newTop')" class="half new-top">
                  {{ seconds }}
                </div>
                <div
                  :style="getFlapStyles('newBottom')"
                  class="half new-bottom flip1">
                  {{ seconds }}
                </div>
                <div
                  :style="getFlapStyles('oldTop')"
                  class="half old-top flip2"></div>
                <div
                  :style="getFlapStyles('oldBottom')"
                  class="half old-bottom"></div>
              </div>
              <div
                :style="getTextStyles('unitText')"
                v-if="element.showUnits"
                class="unit-label">
                {{ element.secondsLabel }}
              </div>
            </div>
            <div
              v-if="
                !element.showUnits
                  && element.showDividers !== false
                  && element.showMilliseconds
              "
              :style="[getTextStyles('timerText'), getDividerStyles()]"
              class="digit">
              .
            </div>
            <div
              v-if="element.showMilliseconds"
              :style="getTimeStyles()"
              class="milliseconds">
              <div
                :style="[getDigitContainerStyles()]"
                class="digit">
                <span
                  v-for="(char, index) in splitDigits(milliseconds, 3)"
                  :key="index"
                  :style="getDigitStyles(index, splitDigits(milliseconds, 3).length)">
                  {{ char }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import elementsMixins from '../../../mixins/elements-mixins';
import resizeMixins from '../../../mixins/resize-mixins';
import moveMixins from '../../../mixins/move-mixins';
import eventBus from '../../../utils/event-bus';

export default {
  name: 'TimerElement',
  mixins: [elementsMixins, resizeMixins, moveMixins],
  data() {
    // durations are in seconds by default, unless this.element.showMilliseconds == true
    return {
      display: '', // timer shown on screen
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
      duration: 0, // total time we're counting down from, or up to (the limit that will stop the timer)
      countdown: 0, // keep track of how many seconds are actively being counted in countdown timer since start pressed
      countupDuration: 0, // keep track of total time counted in stopwatch or count up, used when timer is paused and started again
      countup: 0, // keep track of how many seconds or milliseconds are actively being counted in Count Up timer or stopwatch
      intervalId: null, // keep track of the setInterval which is controlling the timer
      alignTimeout: null, // delayed start so ticks align with whole-second boundaries
      clickTime: null, // track when user clicked dateTime
      startMoment: null, // keep track of when the start button is pressed. used to track the time diff for timers not in real time
    };
  },
  mounted() {
    this.resetTimer();

    this.insertAnimationStyles();

    // set default datetime for date picker (prevents null value)
    if (!this.element.dateTime) this.setDateTime();

    // update default datetime for date picker for more accuracy
    this.$watch(
      () => this.element.counterFormat,
      () => {
        if (this.element.counterFormat == 'Date & Time')
          return this.setDateTime();
      }
    );

    // if the timer type, preview settings, display settings, or datepicker are changed, update
    this.$watch(
      () => [
        this.element.hourPreview,
        this.element.minutePreview,
        this.element.secondPreview,
        this.element.timerFormat,
        this.element.counterFormat,
        this.element.dateTime,
      ],
      () => {
        this.element.play = false; // stop playing if any settings change
        this.resetTimer(); // update timer

        // Date & Time countdowns with a future target run automatically,
        // no Play needed, from the moment they are set.
        this.autoStartDateTimeCountdown();
      }
    );

    // Recalculate the displayed units when which units are shown changes
    // (days/hours/minutes/seconds toggled in the sidebar). The values roll up
    // into the next shown unit, so they need a refresh even though the running
    // timer state itself is unchanged.
    this.$watch(
      () => [
        this.element.showDays,
        this.element.showHours,
        this.element.showMinutes,
        this.element.showSeconds,
        this.element.showMilliseconds,
      ],
      () => this.calculateTime(),
    );

    // update timer when play/paused pressed
    this.$watch(
      () => this.element.play,
      () => this.timer()
    );

    // watch timer, and check if it needs to stop
    this.$watch(
      () => [this.countdown, this.countup, this.duration, this.countupDuration],
      () => this.clearTimer()
    );

    // trigger animation for flip clock
    this.$watch(
      () => [this.days, this.hours, this.minutes, this.seconds],
      (newValues, oldValues) => {
        if (this.element.style == 'Flip clock') {
          const units = [
            { key: 'days', visible: !!this.element.showDays },
            { key: 'hours', visible: !!this.element.showHours },
            { key: 'minutes', visible: !!this.element.showMinutes },
            { key: 'seconds', visible: !!this.element.showSeconds },
          ];

          for (let i = 0; i < units.length; i += 1) {
            // Skip hidden units (their flap nodes aren't in the DOM and there's
            // nothing to animate), and units whose value didn't change.
            if (!units[i].visible || newValues[i] === oldValues[i]) {
              continue;
            }

            const newBottom = document.querySelector(
              `.${units[i].key} > .splitflap > .new-bottom`
            ); // this flips
            const oldTop = document.querySelector(
              `.${units[i].key} > .splitflap > .old-top`
            ); // this flips
            const oldBottom = document.querySelector(
              `.${units[i].key} > .splitflap > .old-bottom`
            );

            // Guard against flap nodes being absent (e.g. a unit that was just
            // toggled off, or mid-transition) before dereferencing them.
            if (!newBottom || !oldTop || !oldBottom) {
              continue;
            }

            // manually set to old value
            oldTop.innerHTML = oldValues[i];
            oldBottom.innerHTML = oldValues[i];

            // manually trigger animation
            newBottom.classList.remove('flip1');
            newBottom.offsetWidth;
            newBottom.classList.add('flip1');

            oldTop.classList.remove('flip2');
            oldTop.offsetWidth;
            oldTop.classList.add('flip2');
          }
        }
      }
    );

    // when reset button is pressed in settings panel
    eventBus.on('reset-timer', this.onResetTimer);

    // Date & Time countdowns with a future target start automatically, no Play needed.
    this.autoStartDateTimeCountdown();

    // this.resizeText();

    // eventBus.on('resize-text', () => {
    //   if(this.isSelected) {
    //     this.resizeText();
    //   }
    // })

    // eventBus.on('draggable-resized', () => {
    //   if(this.isSelected) {
    //     this.resizeText();
    //   }
    // })
  },
  computed: {
    endDateTime() {
      if (this.element.dateTime)
        // the first format string matches the datepicker in timer settings
        return dayjs(this.element.dateTime, 'MM/DD/YYYY hh:mm A').format(
          this.element.endDateTimeFormat
        );

      return null;
    },
  },
  methods: {
    onResetTimer(elementId) {
      if (this.element.id === elementId) {
        this.timer();
        this.resetTimer();
      }
    },
    timer() {
      clearTimeout(this.alignTimeout);

      // if paused, stop timer
      if (!this.element.play) {
        // keep track of the time elapsed when we pause the stopwatch/timer
        if (this.element.timerType == 'Stopwatch')
          this.countupDuration += this.countup;

        if (this.element.counterFormat == 'Time') {
          if (this.element.timerType == 'Countdown') {
            this.duration -= this.countdown;
            this.countdown = 0;
          } else {
            this.countupDuration += this.countup;
            this.countup = 0;
          }
        }

        return clearInterval(this.intervalId);
      }

      // otherwise, set and play timer
      this.startMoment = dayjs();

      const intervalMs = this.element.timerType === 'Stopwatch' ? 1 : 1000;

      if (intervalMs > 1) {
        // Align the first tick with the next whole-second boundary so the
        // displayed values flip at the same moment as other timer renderers.
        // Elapsed time is still derived from real timestamps (`timeDiff`),
        // so the timer itself never drifts.
        this.alignTimeout = setTimeout(() => {
          this.intervalId = setInterval(this.setTimer, intervalMs);
        }, 1000 - (Date.now() % 1000));
      } else {
        this.intervalId = setInterval(this.setTimer, intervalMs);
      }
    },
    clearTimer() {
      // if timer already finished (has met criterion to stop): stop timer by setting play to false and clearing interval
      // stopwatch runs indefinitely, has no stop criteria
      const clear = () => {
        clearInterval(this.intervalId);
        clearTimeout(this.alignTimeout);
        // do not record mutation of play in history
        this.updateElementProp({
          id: this.id,
          propKey: 'play',
          propValue: false,
        }, { blacklist: true });
        return true;
      };

      if (this.element.timerType == 'Countdown') {
        // if the duration for counting down is 0
        if (this.duration <= 0) return clear();
        // or, not real time (real time has no limit for countup, and stops when duration <= 0 for countdown)
        if (!this.element.counterFormat.includes('Date')) {
          // elapsed time has surpassed the limit, or the limit minus the elapsed time has reached 0
          if (
            this.countdown >= this.duration ||
            this.duration - this.countdown <= 0
          )
            return clear();
        }
      }

      if (
        this.element.counterFormat == 'Date & Time' &&
        this.element.dateTime == null
      ) {
        // if null, user cleared the datepicker. value is only set by datepicker.
        return clear();
      }

      return false;
    },
    setTimer() {
      if (this.clearTimer()) return;
      // decrement/increment
      // real time will adjust automatically. otherwise, adjust manually
      if (this.element.timerType == 'Count Up') {
        // Count up or stopwatch should increment.
        if (this.element.counterFormat.includes('Date'))
          this.countupDuration = this.realTimeDiff();
        else this.countup = this.timeDiff();
      } else if (this.element.timerType == 'Stopwatch') {
        this.countup = this.timeDiff();
      } else {
        // countdown should decrement
        if (this.element.counterFormat.includes('Date'))
          this.duration = this.realTimeDiff();
        else this.countdown = this.timeDiff();
      }
      // total amount of time in seconds has been adjusted, now format it for displaying to user
      this.calculateTime();
    },
    timeDiff() {
      // time elapsed since play was pressed
      return dayjs().diff(
        this.startMoment,
        this.element.timerType == 'Stopwatch' ? '' : 'seconds'
      );
    },
    realTimeDiff() {
      // get total time duration for real time (the amount of time between two moments in time)
      // the amount of time between "time now" and a "date in the future".
      // Since "time now" is moving towards the "date in the future", this amount is always decreasing
      if (this.element.timerType == 'Countdown') {
        return dayjs(this.element.dateTime, 'MM/DD/YYYY hh:mm A').diff(
          dayjs(),
          this.element.timerType == 'Stopwatch' ? '' : 'seconds'
        );
      }

      // the amount of time between "time now" and a "date in the past"
      // Since "time now" is always moving away from the "date in the past", this amount is always increasing
      return dayjs().diff(
        dayjs(this.element.dateTime, 'MM/DD/YYYY hh:mm A'),
        this.element.timerType == 'Stopwatch' ? '' : 'seconds'
      );
    },
    calculateTime() {
      // calculate time based on total duration amount in seconds & time values selected in format

      // if we're counting down, use duration. else (count up || stopwatch), use countup
      const duration =
        this.element.timerType == 'Countdown'
          ? this.element.counterFormat == 'Time'
            ? this.duration - this.countdown
            : this.duration // Date & Time (real time)
          : this.element.timerType == 'Count Up'
          ? this.element.counterFormat == 'Time'
            ? this.countupDuration + this.countup
            : this.countupDuration // Date & Time (real time)
          : this.countupDuration + this.countup; // timerType = Stopwatch

      // keep all time in 2-digit format
      const stringify = (int) => {
        if (int < 10) return `0${int.toString()}`;

        return int.toString();
      };

      if (this.element.showDays) {
        // days don't need 2 characters; toString to keep consistent values
        this.days = Math.floor(duration / (60 * 60 * 24)).toString(); // seconds
      } else this.days = 0;

      // When a higher unit is hidden, the next shown unit absorbs the hidden
      // time and shows the total. Once any higher unit is shown, lower units
      // stay in their own range (e.g. with hours shown and minutes hidden,
      // seconds remain 0-59 instead of doing extra math for the minutes).
      if (this.element.showHours) {
        if (this.element.timerType === 'Stopwatch') {
          this.hours = this.element.showDays
            ? stringify(Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
            : stringify(Math.floor(duration / (1000 * 60 * 60)));
        } else {
          this.hours = this.element.showDays
            ? stringify(Math.floor((duration % (60 * 60 * 24)) / (60 * 60)))
            : stringify(Math.floor(duration / (60 * 60)));
        }
      } else this.hours = 0;

      if (this.element.showMinutes) {
        const rollUpMinutes = !this.element.showDays && !this.element.showHours;

        if (this.element.timerType === 'Stopwatch') {
          this.minutes = rollUpMinutes
            ? stringify(Math.floor(duration / (1000 * 60)))
            : stringify(Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60)));
        } else {
          this.minutes = rollUpMinutes
            ? stringify(Math.floor(duration / 60))
            : stringify(Math.floor((duration % (60 * 60)) / 60));
        }
      } else this.minutes = 0;

      if (this.element.showSeconds) {
        const rollUpSeconds = !this.element.showDays
          && !this.element.showHours
          && !this.element.showMinutes;

        if (this.element.timerType === 'Stopwatch') {
          this.seconds = rollUpSeconds
            ? stringify(Math.floor(duration / 1000))
            : stringify(Math.floor((duration % (1000 * 60)) / 1000));
        } else {
          this.seconds = rollUpSeconds
            ? stringify(Math.floor(duration))
            : stringify(Math.floor(duration % 60));
        }
      } else this.seconds = 0;

      if (this.element.timerType == 'Stopwatch') {
        this.milliseconds = Math.floor(duration % 1000);
      } else this.milliseconds = 0;
    },
    resetTimer() {
      // do not record mutation of play in history
      this.updateElementProp({
        id:this.id,
        propKey: 'play',
        propValue: false,
      }, { blacklist: true });

      if (this.element.timerType == 'Stopwatch') {
        this.countupDuration = 0;
        this.countup = 0;
      } else {
        // count up or countdown
        switch (this.element.counterFormat) {
          case 'Time':
            // reset duration based on preview values in settings pane
            this.hours = this.element.hourPreview;
            this.minutes = this.element.minutePreview;
            this.seconds = this.element.secondPreview;

            this.countup = 0;
            this.countdown = 0;
            this.duration = this.element.showMilliseconds
              ? this.hours * (1000 * 60 * 60) +
                this.minutes * (1000 * 60) +
                this.seconds * 1000
              : this.hours * (60 * 60) + this.minutes * 60 + this.seconds;
            this.countupDuration = this.duration;

            break;

          default: // Date & Time
            // reset duration/countup based on real time difference
            if (this.element.dateTime == null) {
              // set values to 0 if user cleared datepicker
              this.days = 0;
              this.hours = 0;
              this.minutes = 0;
              this.seconds = 0;
              return;
            }

            if (this.element.timerType == 'Count Up') {
              this.countupDuration = this.realTimeDiff();
            } else {
              this.duration = this.realTimeDiff();
            }
            break;
        }
      }
      // reset display
      this.calculateTime();
    },
    // resizeText() {
    //   const widget = document.getElementsByClassName('timer-wrapper')[0]
    // },
    setDateTime() {
      const newDateTime =
        this.element.timerType == 'Countdown'
          ? // if countdown, set datepicker 10 days in future
            dayjs().add(10, 'days').format('MM/DD/YYYY hh:mm A')
          : // if countup, set datepicker 10 days in past
            dayjs().subtract(10, 'days').format('MM/DD/YYYY hh:mm A');
      this.updateElementProp({
        id: this.id,
        propKey: 'dateTime',
        propValue: newDateTime,
      });
    },
    autoStartDateTimeCountdown() {
      // Date & Time countdowns derive their remaining time from the target date,
      // so a future target starts automatically without requiring Play.
      // Past (or missing) targets keep the old reset + Play behavior.
      if (
        this.element.timerType !== 'Countdown'
        || this.element.counterFormat !== 'Date & Time'
        || !this.element.dateTime
      ) {
        return;
      }

      if (dayjs(this.element.dateTime, 'MM/DD/YYYY hh:mm A').isAfter(dayjs())) {
        this.element.play = true;
      }
    },
    getTimerStyles() {
      return {
        display: 'flex',
        flexDirection: 'row',
        justifyContent:
          this.element.timerType == 'Stopwatch' ? 'left' : 'center',
        gap: `${this.element.gap ?? 0}px`,
        // Keep digits from shifting horizontally as the numbers change.
        fontVariantNumeric: 'tabular-nums',
        // Never wrap units onto new lines - let the timer overflow the element
        // bounds instead (matches the previous production behavior).
        flexWrap: 'nowrap',
      };
    },
    getTimeStyles() {
      return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '5px',
        // Don't let units shrink (which would wrap their digits).
        flexShrink: 0,
      };
    },
    getDividerStyles() {
      // The ":" glyph is drawn left of center in its advance box, so shift the
      // divider right (and pull the following unit left) to keep the visible
      // space equal on both sides. 0.048em was measured against typical sans
      // fonts (accounting for the digit slots' centered ink); the trailing
      // letter-spacing inside the divider is offset as well so it stays
      // balanced when letter-spacing is set on the timer text.
      const letterSpacing = parseFloat(this.element.styles?.timerText?.letterSpacing) || 0;

      return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 'calc(5px + 0.048em)',
        marginRight: `calc(5px - 0.048em - ${letterSpacing}px)`,
        marginTop: '5px',
        marginBottom: '5px',
        flexShrink: 0,
      };
    },
    getTextStyles(textType) {
      const textStyles = { ...this.element.styles[textType] };

      textStyles.fontSize += 'px';
      textStyles.letterSpacing = textStyles.letterSpacing
        ? `${textStyles.letterSpacing}px`
        : null;

      textStyles.backgroundColor = 'transparent';
      textStyles.lineHeight = textStyles.lineHeight ?? '100%';
      // Keep a unit's value (and its label) on a single line. The per-digit
      // inline-block slots otherwise create break opportunities and can wrap.
      textStyles.whiteSpace = 'nowrap';

      return textStyles;
    },
    splitDigits(value, minLength = 2) {
      // Split a displayed value into individual characters so each digit can
      // render in its own fixed-width slot. Keeps the timer from shifting as
      // values tick, even for fonts that don't support tabular figures.
      return String(value).padStart(minLength, '0').split('');
    },
    getDigitContainerStyles() {
      // Digits are spaced by margins on each fixed-width slot (see
      // getDigitStyles). Zero the container's inherited letter-spacing so it
      // can't shift glyphs inside their slots or add spacing around them.
      return {
        ...this.getTextStyles('timerText'),
        letterSpacing: 0,
      };
    },
    getDigitStyles(index, digitCount) {
      // Fixed-width slot for a single digit. The box width never changes, so
      // replacing the digit content doesn't move the rest of the timer.
      //
      // `letter-spacing` set on the parent `.digit` is ignored for fixed-width
      // inline-block children, so the timer text's letter spacing has to be
      // applied to each slot directly. Add it only *between* digits so a
      // unit's trailing edge doesn't push the divider (`:`) off-center.
      const letterSpacing = Number(this.element.styles?.timerText?.letterSpacing) || 0;
      const isLastDigit = index === digitCount - 1;

      return {
        display: 'inline-block',
        width: '0.6em',
        textAlign: 'center',
        marginRight: isLastDigit ? null : `${letterSpacing}px`,
      };
    },
    getFlipStyles() {
      if (this.element.style == 'Basic') return;

      const { fontSize } = this.element.styles.timerText;

      return {
        height: `${fontSize}px`,
        width: `${fontSize * 2}px`,
        backgroundColor: this.element.flipClockColor,
        top: 0,
        lineHeight: '100%',
        textAlign: 'center',
        borderRadius: '.15em',
        boxShadow: '0 0.025em 0.05em rgba(#000, .25)',
        perspective: '4.5em',
        margin: '5px',
      };
    },
    getFlapStyles(position) {
      if (this.element.style == 'Basic') return;

      if (position == 'newTop') {
        return {
          backgroundColor: this.element.flipClockColor,
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '50%',
          borderRadius: '.15em .15em 0 0',
          overflow: 'hidden',
          zIndex: 2,
          borderBottom: '1px solid grey',
        };
      }

      if (position == 'newBottom') {
        return {
          backgroundColor: this.element.flipClockColor,
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          borderRadius: '.15em',
          webkitTransform: 'rotate3D(1, 0, 0, 90deg)',
          transform: 'rotate3D(1, 0, 0, 90deg)',
          webkitTransformOrigin: 'center',
          transformOrigin: 'center',
          webkitBackfaceVisibility: 'hidden',
          backfaceVisibility: 'hidden',
          zIndex: -2,
        };
      }

      if (position == 'oldTop') {
        return {
          backgroundColor: this.element.flipClockColor,
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '50%',
          borderRadius: '.15em .15em 0 0',
          webkitTransform: 'rotate3D(1, 0, 0, 0deg)',
          transform: 'rotate3D(1, 0, 0, 0deg)',
          webkitTransformOrigin: 'bottom',
          transformOrigin: 'bottom',
          webkitBackfaceVisibility: 'hidden',
          backfaceVisibility: 'hidden',
          overflow: 'hidden',
          zIndex: 3,
          borderBottom: '1px solid grey',
        };
      }

      if (position == 'oldBottom') {
        return {
          backgroundColor: this.element.flipClockColor,
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          borderRadius: '.15em',
          zIndex: -3,
        };
      }
    },
    insertAnimationStyles() {
      const style = document.createElement('style');
      document.head.appendChild(style);
      const styleSheet = style.sheet;

      styleSheet.insertRule(`
        .flip1 {
          -webkit-animation: flip1 1s ease-in forwards;
          animation: flip1 1s ease-in forwards;
        }
      `);

      styleSheet.insertRule(`
        .flip2 {
          -webkit-animation: flip2 1s ease-in forwards;
          animation: flip2 1s ease-in forwards;
        }
      `);

      styleSheet.insertRule(`
        @-webkit-keyframes flip1 {
          0% {
            -webkit-transform: rotate3D(1, 0, 0, 90deg);
            transform: rotate3D(1, 0, 0, 90deg);
            z-index: -2;
          }
        
          50% {
            -webkit-transform: rotate3D(1, 0, 0, 90deg);
            transform: rotate3D(1, 0, 0, 90deg);
            z-index: -2;
          }
        
          100% {
            -webkit-transform: rotate3D(1, 0, 0, 0deg);
            transform: rotate3D(1, 0, 0, 0deg);
            z-index: -2;
          }
        }
      `);

      styleSheet.insertRule(`
        @keyframes flip1 {
          0% {
            -webkit-transform: rotate3D(1, 0, 0, 90deg);
            transform: rotate3D(1, 0, 0, 90deg);
            z-index: -2;
          }
        
          50% {
            -webkit-transform: rotate3D(1, 0, 0, 90deg);
            transform: rotate3D(1, 0, 0, 90deg);
            z-index: -2;
          }
        
          100% {
            -webkit-transform: rotate3D(1, 0, 0, 0deg);
            transform: rotate3D(1, 0, 0, 0deg);
            z-index: -2;
          }
        }
      `);

      styleSheet.insertRule(`
        @-webkit-keyframes flip2 {
          0% {
            -webkit-transform: rotate3D(1, 0, 0, 0deg);
            transform: rotate3D(1, 0, 0, 0deg);
            z-index: 3;
          }
        
          50% {
            -webkit-transform: rotate3D(1, 0, 0, -90deg);
            transform: rotate3D(1, 0, 0, -90deg);
            z-index: 3;
          }
        
          100% {
            -webkit-transform: rotate3D(1, 0, 0, -90deg);
            transform: rotate3D(1, 0, 0, -90deg);
            z-index: 3;
          }
        }
      `);

      styleSheet.insertRule(`
        @keyframes flip2 {
          0% {
            -webkit-transform: rotate3D(1, 0, 0, 0deg);
            transform: rotate3D(1, 0, 0, 0deg);
            z-index: 3;
          }
        
          50% {
            -webkit-transform: rotate3D(1, 0, 0, -90deg);
            transform: rotate3D(1, 0, 0, -90deg);
            z-index: 3;
          }
        
          100% {
            -webkit-transform: rotate3D(1, 0, 0, -90deg);
            transform: rotate3D(1, 0, 0, -90deg);
            z-index: 3;
          }
        }
      `);
    },
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
    clearTimeout(this.alignTimeout);
    eventBus.off('reset-timer', this.onResetTimer);
  },
};
</script>
